import React from 'react';
import { EVENT_YEAR, EVENT_EDITION } from '../../utils/eventConfig';

const PAINT_GRADIENT = 'linear-gradient(to right, #B8185E, #1B5EA8, #E8B428, #C8392B, #2D7A50)';

const Header = () => {
  return (
    <header className="bg-primary text-white shadow-md">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <h1 className="text-xl md:text-2xl font-heading font-bold tracking-wide">
              Letavy {EVENT_YEAR}
            </h1>
            <span className="text-sm md:text-base text-white/60 font-heading">
              {EVENT_EDITION}. ročník
            </span>
          </div>
          <div className="text-sm md:text-base text-white/60">
            Registračný systém
          </div>
        </div>
      </div>
      <div style={{ background: PAINT_GRADIENT, height: '4px' }} />
    </header>
  );
};

export default Header;
